/* eslint-disable max-len */
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import * as UsersActions from '../actions/Users';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import recover from '../Res/Icon/recover.png';
import Status2FA from './2FAStatus';
import UserStatus from './UserStatus';
import utils from '../lib/utils';
const User = ({
  user,
  disabled,
  onDelete,
  onSetStatus,
  userApp,
  showUpdateUser,
  initialUpdateUserData,
  deleteMode,
  onRecover,
  userRole,
  loggedInUser
}) => {
  const {
    _id: id,
    email,
    name,
    role,
    enabled,
    registerDate,
    lastLoggedIn,
    twoFactor,
    companyName,
    company,
    companyType,
  } = user;
  const isConpanyType = companyType || company?.companyType;

  const getLastActiveDate = date => {
    if (date) {
      const lastLoggedIn = new Date(date);
      const now = new Date();

      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;

      const timeDiffInMs = now.getTime() - lastLoggedIn.getTime();

      if (timeDiffInMs >= thirtyDaysInMs) return 'No Activity for last 30 day';

      return lastLoggedIn.toDateString();
    }
    return 'N/A';
  };
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    console.log('toggleTooltip', tooltipOpen);
    setTooltipOpen(!tooltipOpen);
  };
  return (
    <>
      <tr>
        {
          utils.filterCustomer(userRole) ? (<td>{id}</td>) : null
        }
        <td>{companyName || company?.name}</td>
        <td>{email}</td>
        <td
          id={`user-name-${id}`}
          style={{ 
            color: (user?.userNote?.noteText && loggedInUser.permissionsGroup === 'Engineering') ? '#db0b0b' : 'black', 
            fontWeight: (user?.userNote?.noteText && loggedInUser.permissionsGroup === 'Engineering') ? 'bold' : 'normal'
          }}
        >
          {name}
          {(user?.userNote?.noteText && loggedInUser.permissionsGroup === 'Engineering') && <Tooltip
            delay={0}
            placement='bottom'
            isOpen={tooltipOpen}
            target={`user-name-${id}`}
            toggle={toggleTooltip}
            title={user?.userNote?.noteText}>
            {user?.userNote?.noteText}
          </Tooltip>}
        </td>
        <td>
          {isConpanyType !== 'manufacturer' ? role : role === 'superAdmin' ? 'manufacturer' : role}
        </td>
        <td>
          <UserStatus
            canChange={disabled}
            enabled={enabled}
            onSetStatus={() => {
              onSetStatus(id, !enabled, 'Status');
            }}
          />
        </td>
        <td>
          <Status2FA twoFactor={twoFactor} onSetStatus={() => onSetStatus(id, !twoFactor, '2FA')} />
        </td>
        <td>{utils.getDateTimeFormat(registerDate, 'regular')}</td>
        <td>{getLastActiveDate(lastLoggedIn)}</td>
        {
            (userApp.role === 'admin' ||
              userApp.role === 'enterpriseAdmin' ||
              userApp.role === 'superAdmin' ||
              userApp.role === 'companyGroupAdmin' ||
              userApp.role === 'companyGroupManager') && (
              <td style={{ minWidth: '100px' }}>
                {(userApp.role === 'superAdmin' ||
                  userApp.role === 'admin' ||
                  userApp.role === 'enterpriseAdmin' ||
                  userApp.role === 'companyGroupAdmin' ||
                  userApp.role === 'companyGroupManager') &&
                  ((user.role === 'superAdmin' && userApp.role === 'companyGroupManager') ||
                    (user.role === 'companyGroupAdmin' &&
                      userApp.role === 'companyGroupManager') ? null : !deleteMode ? (
                        <img
                          onClick={() => {
                            initialUpdateUserData(user);
                            showUpdateUser();
                          }}
                          className="actions-icon"
                          src={edit}
                          alt="edit"
                        />
                      ) : (
                    <img
                      onClick={() => onRecover(id)}
                      className="actions-icon"
                      src={recover}
                      alt="recover"
                    />
                  ))}

                {(userApp.role === 'companyGroupAdmin' && user.role === 'superAdmin') ||
                  (userApp.role === 'companyGroupAdmin' && user.role === 'companyGroupAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'superAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'companyGroupAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'companyGroupManager') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'superAdmin') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'companyGroupAdmin') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'companyGroupManager') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    (user.role === 'admin' || user.role === 'enterpriseAdmin')) ? (
                  ''
                ) : (
                  // <Button
                  //   color="danger"
                  //   onClick={() => {
                  //     onDelete(id);
                  //   }}
                  //   disabled={disabled}
                  // >
                  //   Delete
                  // </Button>
                  <img
                    onClick={() => {
                      onDelete(user);
                    }}
                    disabled={disabled}
                    className="actions-icon"
                    src={del}
                    alt="delete"
                  />
                )}
              </td>
            )}
      </tr>
    </>
  );
};

const mapStateToProps = state => ({
  userApp: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  showUpdateUser: () => dispatch(UsersActions.showUpdateUser()),
  initialUpdateUserData: userObj => dispatch(UsersActions.initialUpdateUserData(userObj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(User);
